"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("../_internal/utils");
var isArray_1 = tslib_1.__importDefault(require("../isArray"));
var pipe1_1 = tslib_1.__importDefault(require("../pipe1"));
var toArray_1 = tslib_1.__importDefault(require("../toArray"));
function shuffle(iterable) {
    var _a;
    if ((0, isArray_1.default)(iterable)) {
        var result = (0, toArray_1.default)(iterable);
        for (var i = result.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            _a = tslib_1.__read([result[j], result[i]], 2), result[i] = _a[0], result[j] = _a[1];
        }
        return result;
    }
    if ((0, utils_1.isIterable)(iterable)) {
        return (0, pipe1_1.default)((0, toArray_1.default)(iterable), function (arr) {
            var _a;
            var result = arr;
            for (var i = result.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                _a = tslib_1.__read([result[j], result[i]], 2), result[i] = _a[0], result[j] = _a[1];
            }
            return result;
        });
    }
    if ((0, utils_1.isAsyncIterable)(iterable)) {
        return (0, pipe1_1.default)((0, toArray_1.default)(iterable), function (arr) {
            var _a;
            var result = arr;
            for (var i = result.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                _a = tslib_1.__read([result[j], result[i]], 2), result[i] = _a[0], result[j] = _a[1];
            }
            return result;
        });
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
exports.default = shuffle;
//# sourceMappingURL=shuffle.js.map